// Shared by the Appraisal Admin, Talent Committees, and TC Run views so their STATUS
// columns can't drift apart.

export const appraisalStatusDisplayLabels: Record<string, string> = {
  NotStarted: 'NOT STARTED',
  SelfAssessment: 'SELF-ASSESSMENT',
  CollatorReview: 'COLLATOR REVIEW',
  CollatorUpdates: 'COLLATOR UPDATES',
  TcReview: 'TC REVIEW',
  AwaitingHrGuidance: 'AWAITING HR GUIDANCE',
  StaffingReview: 'STAFFING REVIEW',
  StaffingAccepted: 'STAFFING ACCEPTED',
  ReadyForDelivery: 'READY FOR DELIVERY',
  Delivered: 'DELIVERED',
  DeliveryAcknowledged: 'DELIVERY ACKNOWLEDGED',
};

export function formatAppraisalStatusLabel(status: string): string {
  return appraisalStatusDisplayLabels[status] || status.toUpperCase();
}

export function getAppraisalStatusChipSx(status: string) {
  switch (status) {
    case 'NotStarted':
      return { bgcolor: '#EBEBEB', color: 'black' };
    case 'SelfAssessment':
      return { bgcolor: '#E91E63', color: 'white' };
    case 'CollatorReview':
      return { bgcolor: '#9C27B0', color: 'white' };
    case 'CollatorUpdates':
      return { bgcolor: '#FF5722', color: 'white' };
    case 'TcReview':
      return { bgcolor: '#00BCD4', color: 'white' };
    case 'Delivered':
      return { bgcolor: '#4CAF50', color: 'white' };
    case 'DeliveryAcknowledged':
      return { bgcolor: '#FF9800', color: 'white' };
    case 'AwaitingHrGuidance':
      return { bgcolor: '#607D8B', color: 'white' };
    case 'StaffingReview':
      return { bgcolor: '#795548', color: 'white' };
    case 'StaffingAccepted':
      return { bgcolor: '#009688', color: 'white' };
    case 'ReadyForDelivery':
      return { bgcolor: '#8BC34A', color: 'white' };
    default:
      return { bgcolor: 'grey.400', color: 'white' };
  }
}
